const updateCommand = async ({ params, api }) => {
  const { previousData } = params;
  const { id } = previousData;
  return await api(`commands/${id}`, { body: params.data, method: 'PUT' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default updateCommand;